import React from "react";

/**
 * Component to render the logo of a financial instituition
 *
 * An `institution` prop containing the `logo` for the url and `name` for the alt text is required
 *
 * Clicking on the logo will navigate to the root page of the domain
 */
const InstitutionLogo = ({
  className = "",
  institution,
  logoUrl = "",
}: {
  institution: { logo: string; name: string };
  className?: string;
  logoUrl?: string;
}) => {
  const { logo, name } = institution;
  const href = logoUrl?.trim() ? logoUrl : "/";
  return logo && name ? (
    <a
      className={`institution-logo ${className}`}
      style={{ backgroundImage: `url(${logo})` }}
      href={href}
      target={logoUrl?.trim() ? "_blank" : undefined}
      rel={logoUrl?.trim() ? "noopener noreferrer" : undefined}
      aria-label={`${name} Logo`}
    >
      {name} Logo
    </a>
  ) : null;
};

export default InstitutionLogo;
